module.exports = __webpack_public_path__ + "img/workyw.53539e9e.png";